import {ComponentType} from "@angular/cdk/portal";
import {ComponentFactoryResolver, Injectable} from "@angular/core";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) { }

  showGeneralMessage(
    message: string,
    durationSec = 2,
    extraPanelClass: string = null
  ) {
    const config = new MatSnackBarConfig();
    config.verticalPosition = "top";
    config.horizontalPosition = "center";
    config.duration = durationSec * 1000;

    const classes = ["general-message-snackbar"];
    if (extraPanelClass && extraPanelClass.length > 0) {
      classes.push(extraPanelClass);
    }

    config.panelClass = classes;
    this.snackBar.open(message, null, config);
  }

  showSnackbarFromComponent<T>(
    component: ComponentType<T>,
    data: any,
    durationSec = 2,
    extraPanelClass: string = null
  ) {
    const config = new MatSnackBarConfig();
    config.verticalPosition = "top";
    config.horizontalPosition = "center";
    config.duration = durationSec * 1000;
    config.data = data;

    const classes = [];
    if (extraPanelClass && extraPanelClass.length > 0) {
      classes.push(extraPanelClass);
    }

    config.panelClass = classes;
    this.snackBar.openFromComponent(component, config);
  }
}
